module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('header', [_c('h2', {
    staticClass: "h2f"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vii"
    }
  }, [_vm._v("CONTENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/foreword"
    }
  }, [_c('strong', [_vm._v("Foreword by Billy Crystal")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/preface"
    }
  }, [_c('strong', [_vm._v("Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch01"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('span', {
    staticClass: "toc1"
  }, [_vm._v("1")]), _c('br'), _c('strong', [_vm._v("The Catskills Comics")]), _vm._v(" ("), _c('em', [_vm._v("Writing for the Wrong People)")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('span', {
    staticClass: "toc1"
  }, [_vm._v("2")]), _c('br'), _c('strong', [_vm._v("The Club Year")]), _vm._v(" ("), _c('em', [_vm._v("A Large Jew Sweating)")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('span', {
    staticClass: "toc1"
  }, [_vm._v("3")]), _c('br'), _c('strong', [_vm._v("Saturday Night Live")]), _vm._v(" ("), _c('em', [_vm._v("The Early Part of the Early Years)")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('span', {
    staticClass: "toc1"
  }, [_vm._v("4")]), _c('br'), _c('strong', [_vm._v("Saturday Night Live")]), _vm._v(" ("), _c('em', [_vm._v("The Later Part of the Early Years)")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('span', {
    staticClass: "toc1"
  }, [_vm._v("5")]), _c('br'), _c('strong', [_vm._v("Former "), _c('em', [_vm._v("SNL")]), _vm._v(" Writer")]), _vm._v(" ("), _c('em', [_vm._v("Looking for New Voices)")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('span', {
    staticClass: "toc1"
  }, [_vm._v("6")]), _c('br'), _c('strong', [_vm._v("Lightning Strikes Again")]), _vm._v(" (It’s Garry Shandling’s Show)")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('span', {
    staticClass: "toc1"
  }, [_vm._v("7")]), _c('br'), _c('strong', [_vm._v("Good Sports")]), _vm._v(" ("), _c('em', [_vm._v("Writing for the Wrong People … Again)")])])]), _vm._v(" "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_viii"
    }
  }, [_c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('span', {
    staticClass: "toc1"
  }, [_vm._v("8")]), _c('br'), _c('strong', [_vm._v("Crashing and Burning in Another Genre")]), _vm._v(" (North "), _c('em', [_vm._v("Goes South)")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('span', {
    staticClass: "toc1"
  }, [_vm._v("9")]), _c('br'), _c('strong', [_vm._v("Bunny Bunny")]), _vm._v(" "), _c('em', [_vm._v("(Even in Death Gilda Saves My Ass)")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('span', {
    staticClass: "toc1"
  }, [_vm._v("10")]), _c('br'), _c('strong', [_vm._v("700 Sundays")]), _vm._v(" "), _c('em', [_vm._v("(Billy Crystal and the Rise of the One-Man Show)")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('span', {
    staticClass: "toc1"
  }, [_vm._v("11")]), _c('br'), _c('strong', [_vm._v("Unfinished Business")]), _vm._v(" "), _c('em', [_vm._v("(Saying Goodbye to Garry)")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('span', {
    staticClass: "toc1"
  }, [_vm._v("12")]), _c('br'), _c('strong', [_vm._v("Another Kind of Collaboration")]), _vm._v(" "), _c('em', [_vm._v("(Dave Barry and Others Who Spend Their Days Alone)")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('span', {
    staticClass: "toc1"
  }, [_vm._v("13")]), _c('br'), _c('strong', [_vm._v("Giant Shadows")]), _vm._v(" "), _c('em', [_vm._v("(Lessons from Heroes)")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('span', {
    staticClass: "toc1"
  }, [_vm._v("14")]), _c('br'), _c('strong', [_vm._v("In Progress")]), _vm._v(" (Here Today)")])]), _vm._v(" "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_ix"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_x"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 75
// module chunks = 0